import { useEffect, useCallback } from 'react';

export function useClickOutside(callback: () => void, refsToIgnore: React.RefObject<Element | null>[] = []) {
    const handleClick = useCallback(
        (e: MouseEvent) => {
            const target = e.target as Node;

            const isInsideIgnored = refsToIgnore.some(ref => ref.current?.contains(target));

            if (!isInsideIgnored) {
                callback();
            }
        },
        [callback, refsToIgnore],
    );

    useEffect(() => {
        document.addEventListener('mousedown', handleClick);

        return () => {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [handleClick]);
}
